import * as React from "react";

interface Props {
  active: "down" | "up" | "none";
}
export const ColumnSort: React.FC<Props> = ({ active }) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const size = 6;

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="flex flex-col gap-1 ml-4"
    >
      <span
        style={{
          width: 0,
          height: 0,
          borderLeft: `${size}px solid transparent`,
          borderRight: `${size}px solid transparent`,
          borderBottom: `${size}px solid ${
            active === "up" ? "var(--color-link)" : isHovered ? "var(--color-gray-500)" : "var(--color-default)"
          }`,
        }}
      />
      <span
        style={{
          width: 0,
          height: 0,
          borderLeft: `${size}px solid transparent`,
          borderRight: `${size}px solid transparent`,
          borderTop: `${size}px solid ${
            active === "down" ? "var(--color-link)" : isHovered ? "var(--color-gray-500)" : "var(--color-default)"
          }`,
        }}
      />
    </div>
  );
};
